import { createRouter, createWebHistory } from 'vue-router';

import LoginPage from '@/views/LoginPage.vue';
import type { AppPage, AppRoute, RouteAccess } from '@/types';
import { UserRole } from '@/types';
import { canUserAccess } from '@/router/canUserAccess';

export const appRoutes: Record<AppPage, AppRoute> = {
  loginPage: {
    path: '/',
    name: 'login',
  },
  mainPage: {
    path: '/app',
    name: 'main',
    restrictedToRoles: [UserRole.residentSupporter],
  },
  searchThingsPage: {
    path: '/search-things/:searchTerm?',
    name: 'searchThings',
    restrictedToRoles: [UserRole.residentSupporter],
  },
  searchByBillingUnitPage: {
    path: '/search-by-billing-unit',
    name: 'searchByBillingUnit',
    restrictedToRoles: [UserRole.residentSupporter],
  },
  searchByAddressPage: {
    path: '/search-by-address',
    name: 'searchByAddress',
    restrictedToRoles: [UserRole.residentSupporter],
  },
  notAuthorizedPage: {
    path: '/not-authorized',
    name: 'not-authorized',
  },
  authPopupCallback: {
    path: '/auth/signinpop/main',
    name: 'auth-popup-callback',
  },
};

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: appRoutes.loginPage.path,
      name: appRoutes.loginPage.name,
      component: LoginPage,
    },
    {
      path: appRoutes.mainPage.path,
      name: appRoutes.mainPage.name,
      component: () => import('@/views/MainPage/MainPage.vue'),
    },
    {
      path: appRoutes.searchThingsPage.path,
      name: appRoutes.searchThingsPage.name,
      component: () => import('@/views/SearchThingsPage/SearchThingsPage.vue'),
    },
    {
      path: appRoutes.searchByBillingUnitPage.path,
      name: appRoutes.searchByBillingUnitPage.name,
      component: () => import('@/views/SearchPropertiesPage/SearchPropertiesPage.vue'),
    },
    {
      path: appRoutes.searchByAddressPage.path,
      name: appRoutes.searchByAddressPage.name,
      component: () => import('@/views/SearchPropertiesPage/SearchPropertiesPage.vue'),
    },
    {
      path: appRoutes.notAuthorizedPage.path,
      name: appRoutes.notAuthorizedPage.name,
      component: () => import('@/views/NotAuthorizedPage/NotAuthorizedPage.vue'),
    },
    {
      path: appRoutes.authPopupCallback.path,
      name: appRoutes.authPopupCallback.name,
      component: () => import('@/views/AuthPopupCallback.vue'),
    },
  ],
});

router.beforeEach(async (to) => {
  const toRoute: AppRoute | undefined = Object.values(appRoutes).find((aR) => aR.name === to.name);
  if (!toRoute) {
    throw new Error('Trying to access undefined route!');
  }

  const routeAccess: RouteAccess = canUserAccess(toRoute);
  if (!routeAccess.canAccess) {
    return routeAccess.redirectTo?.path || false;
  }
});
